/**
 * Feature detection for the two platform APIs every Brian overlay is built on:
 * modal `<dialog>` and the Popover API. Returns false during SSR, so callers
 * must treat a false result as "not known to be supported yet" on the server.
 */
export function browserSupportsBrian(): boolean {
  if (typeof window === "undefined") return false;

  const hasModalDialog =
    typeof window.HTMLDialogElement === "function" &&
    typeof window.HTMLDialogElement.prototype.showModal === "function";

  const hasPopover =
    typeof window.HTMLElement === "function" &&
    typeof window.HTMLElement.prototype.showPopover === "function";

  return hasModalDialog && hasPopover;
}
